webpackJsonp([231608221292675],{

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.apiRunner = apiRunner;
	exports.apiRunnerAsync = apiRunnerAsync;
	var plugins = [{
	  plugin: __webpack_require__(330),
	  options: { "plugins": [] }
	}];
	// During bootstrap, we write requires at top of this file which looks
	// basically like:
	// var plugins = [
	//   {
	//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
	//     options: { ... },
	//   },
	//   {
	//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
	//     options: { ... },
	//   },
	// ]
	
	function apiRunner(api, args, defaultReturn) {
	  var results = plugins.map(function (plugin) {
	    if (plugin.plugin[api]) {
	      var result = plugin.plugin[api](args, plugin.options);
	      return result;
	    }
	  });
	
	  // Filter out undefined results.
	  results = results.filter(function (result) {
	    return typeof result !== "undefined";
	  });
	
	  if (results.length > 0) {
	    return results;
	  } else if (defaultReturn) {
	    return [defaultReturn];
	  } else {
	    return [];
	  }
	}
	
	function apiRunnerAsync(api, args, defaultReturn) {
	  return plugins.reduce(function (previous, next) {
	    return next.plugin[api] ? previous.then(function () {
	      return next.plugin[api](args, next.options);
	    }) : previous;
	  }, Promise.resolve());
	}

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// prefer default export if available
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	
	exports.components = {
	  "component---src-pages-404-tsx": __webpack_require__(491),
	  "component---src-pages-biuro-rachunkowe-tsx": __webpack_require__(492),
	  "component---src-pages-cennik-tsx": __webpack_require__(493),
	  "component---src-pages-cookies-tsx": __webpack_require__(494),
	  "component---src-pages-dotacje-tsx": __webpack_require__(495),
	  "component---src-pages-faq-tsx": __webpack_require__(496),
	  "component---src-pages-funkcje-tsx": __webpack_require__(497),
	  "component---src-pages-index-tsx": __webpack_require__(498),
	  "component---src-pages-kalkulator-wynagrodzen-tsx": __webpack_require__(499),
	  "component---src-pages-kontakt-tsx": __webpack_require__(500),
	  "component---src-pages-likwidacja-spolek-tsx": __webpack_require__(501),
	  "component---src-pages-nasz-zespol-tsx": __webpack_require__(502),
	  "component---src-pages-polityka-rachunkowosci-tsx": __webpack_require__(503),
	  "component---src-pages-porownanie-pakietow-tsx": __webpack_require__(504),
	  "component---src-pages-program-do-faktur-tsx": __webpack_require__(505),
	  "component---src-pages-regulamin-tsx": __webpack_require__(506),
	  "component---src-pages-zakladanie-spolek-zoo-tsx": __webpack_require__(507)
	};
	
	exports.json = {
	  "layout-index.json": __webpack_require__(508),
	  "404.json": __webpack_require__(509),
	  "biuro-rachunkowe.json": __webpack_require__(511),
	  "cennik.json": __webpack_require__(512),
	  "cookies.json": __webpack_require__(513),
	  "dotacje.json": __webpack_require__(514),
	  "faq.json": __webpack_require__(515),
	  "funkcje.json": __webpack_require__(516),
	  "index.json": __webpack_require__(517),
	  "kalkulator-wynagrodzen.json": __webpack_require__(518),
	  "kontakt.json": __webpack_require__(519),
	  "likwidacja-spolek.json": __webpack_require__(520),
	  "nasz-zespol.json": __webpack_require__(521),
	  "polityka-rachunkowosci.json": __webpack_require__(522),
	  "porownanie-pakietow.json": __webpack_require__(523),
	  "program-do-faktur.json": __webpack_require__(524),
	  "regulamin.json": __webpack_require__(525),
	  "zakladanie-spolek-zoo.json": __webpack_require__(526),
	  "404-html.json": __webpack_require__(510)
	};
	
	exports.layouts = {
	  "layout---index": __webpack_require__(490)
	};

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _loader = __webpack_require__(209);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	var _emitter = __webpack_require__(103);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _apiRunnerBrowser = __webpack_require__(140);
	
	var _shallowCompare = __webpack_require__(810);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultLayout = function DefaultLayout(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    null,
	    children()
	  );
	};
	
	// Pass pathname in as prop.
	// component will try fetching resources. If they exist,
	// will just render, else will render null.
	
	var ComponentRenderer = function (_React$Component) {
	  _inherits(ComponentRenderer, _React$Component);
	
	  function ComponentRenderer(props) {
	    _classCallCheck(this, ComponentRenderer);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    var location = props.location;
	
	    // Set the pathname for 404 pages.
	    if (!_loader2.default.getPage(location.pathname)) {
	      location = _extends({}, location, {
	        pathname: "/404.html"
	      });
	    }
	
	    _this.state = {
	      location: location,
	      pageResources: _loader2.default.getResourcesForPathname(location.pathname)
	    };
	    return _this;
	  }
	
	  ComponentRenderer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    // During development, always pass a component's JSON through so graphql
	    // updates go through.
	    if (false) {
	      if (nextProps && nextProps.pageResources && nextProps.pageResources.json) {
	        this.setState({ pageResources: nextProps.pageResources });
	      }
	    }
	    if (this.state.location.pathname !== nextProps.location.pathname) {
	      var pageResources = _loader2.default.getResourcesForPathname(nextProps.location.pathname);
	      if (!pageResources) {
	        var location = nextProps.location;
	
	        // Set the pathname for 404 pages.
	        if (!_loader2.default.getPage(location.pathname)) {
	          location = _extends({}, location, {
	            pathname: "/404.html"
	          });
	        }
	
	        // Page resources won't be set in cases where the browser back button
	        // or forward button is pushed as we can't wait as normal for resources
	        // to load before changing the page.
	        _loader2.default.getResourcesForPathname(location.pathname, function (pageResources) {
	          _this2.setState({
	            location: location,
	            pageResources: pageResources
	          });
	        });
	      } else {
	        this.setState({
	          location: nextProps.location,
	          pageResources: pageResources
	        });
	      }
	    }
	  };
	
	  ComponentRenderer.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    // Listen to events so when our page gets updated, we can transition.
	    // This is only useful on delayed transitions as the page will get rendered
	    // without the necessary page resources and then re-render once those come in.
	    _emitter2.default.on("onPostLoadPageResources", function (e) {
	      if (_loader2.default.getPage(_this3.state.location.pathname) && e.page.path === _loader2.default.getPage(_this3.state.location.pathname).path) {
	        _this3.setState({ pageResources: e.pageResources });
	      }
	    });
	  };
	
	  ComponentRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    // 404
	    if (!nextState.pageResources) {
	      return true;
	    }
	    // Check if the component or json have changed.
	    if (!this.state.pageResources && nextState.pageResources) {
	      return true;
	    }
	    if (this.state.pageResources.component !== nextState.pageResources.component) {
	      return true;
	    }
	
	    if (this.state.pageResources.json !== nextState.pageResources.json) {
	      return true;
	    }
	
	    // Check if location has changed on a page using internal routing
	    // via matchPath configuration.
	    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
	      return true;
	    }
	
	    return (0, _shallowCompare2.default)(this, nextProps, nextState);
	  };
	
	  ComponentRenderer.prototype.render = function render() {
	    var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceComponentRenderer", {
	      props: _extends({}, this.props, { pageResources: this.state.pageResources }),
	      loader: _loader.publicLoader
	    });
	    var replacementComponent = pluginResponses[0];
	    // If page.
	    if (this.props.page) {
	      if (this.state.pageResources) {
	        return replacementComponent || (0, _react.createElement)(this.state.pageResources.component, _extends({
	          key: this.props.location.pathname
	        }, this.props, this.state.pageResources.json));
	      } else {
	        return null;
	      }
	      // If layout.
	    } else if (this.props.layout) {
	      return replacementComponent || (0, _react.createElement)(this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : DefaultLayout, _extends({
	        key: this.state.pageResources && this.state.pageResources.layout ? this.state.pageResources.layout : "DefaultLayout"
	      }, this.props));
	    } else {
	      return null;
	    }
	  };
	
	  return ComponentRenderer;
	}(_react2.default.Component);
	
	ComponentRenderer.propTypes = {
	  page: _propTypes2.default.bool,
	  layout: _propTypes2.default.bool,
	  location: _propTypes2.default.object
	};
	
	exports.default = ComponentRenderer;
	module.exports = exports["default"];

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _mitt = __webpack_require__(679);
	
	var _mitt2 = _interopRequireDefault(_mitt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emitter = (0, _mitt2.default)();
	module.exports = emitter;

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _reactRouterDom = __webpack_require__(139);
	
	var _stripPrefix = __webpack_require__(210);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO add tests especially for handling prefixed links.
	var pageCache = {};
	
	module.exports = function (pages) {
	  var pathPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	  return function (rawPathname) {
	    var pathname = decodeURIComponent(rawPathname);
	
	    // Remove the pathPrefix from the pathname.
	    var trimmedPathname = (0, _stripPrefix2.default)(pathname, pathPrefix);
	
	    // Remove any hashfragment
	    if (trimmedPathname.split("#").length > 1) {
	      trimmedPathname = trimmedPathname.split("#").slice(0, -1).join("");
	    }
	
	    // Remove search query
	    if (trimmedPathname.split("?").length > 1) {
	      trimmedPathname = trimmedPathname.split("?").slice(0, -1).join("");
	    }
	
	    if (pageCache[trimmedPathname]) {
	      return pageCache[trimmedPathname];
	    }
	
	    var foundPage = void 0;
	    // Array.prototype.find is not supported in IE so we use this somewhat odd
	    // work around.
	    pages.some(function (page) {
	      if (page.matchPath) {
	        // Try both the path and matchPath
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, { path: page.path }) || (0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.matchPath
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      } else {
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path,
	          exact: true
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	
	        // Finally, try and match request with default document.
	        if ((0, _reactRouterDom.matchPath)(trimmedPathname, {
	          path: page.path + "index.html"
	        })) {
	          foundPage = page;
	          pageCache[trimmedPathname] = page;
	          return true;
	        }
	      }
	
	      return false;
	    });
	
	    return foundPage;
	  };
	};

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createBrowserHistory = __webpack_require__(176);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _apiRunnerBrowser = __webpack_require__(140);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pluginResponses = (0, _apiRunnerBrowser.apiRunner)("replaceHistory");
	var replacementHistory = pluginResponses[0];
	var history = replacementHistory || (0, _createBrowserHistory2.default)();
	module.exports = history;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178698757827068, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(534) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(254022195166212, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(535) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(44313024792962, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(536) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(56543095516091, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(537) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(130775755813921, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(538) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(184521674324067, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(539) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(84887730282209, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(540) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(123199777968094, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(541) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142629428675168, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(542) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(264833215644647, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(543) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(210605642136508, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(544) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(60335399758886, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(179) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(72060917668982, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(545) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(55334231626863, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(546) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(82953272724940, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(547) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(147893789269391, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(548) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(205747370823061, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(549) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(32102591696690, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(550) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(25264417577923, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(551) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(22676092666560, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(327) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	exports.__esModule = true;
	exports.publicLoader = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _findPage = __webpack_require__(325);
	
	var _findPage2 = _interopRequireDefault(_findPage);
	
	var _emitter = __webpack_require__(103);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _stripPrefix = __webpack_require__(210);
	
	var _stripPrefix2 = _interopRequireDefault(_stripPrefix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findPage = void 0;
	
	var syncRequires = {};
	var asyncRequires = {};
	var pathScriptsCache = {};
	var resourceStrCache = {};
	var resourceCache = {};
	var pages = [];
	// Note we're not actively using the path data atm. There
	// could be future optimizations however around trying to ensure
	// we load all resources for likely-to-be-visited paths.
	var pathArray = [];
	var pathCount = {};
	var pathPrefix = "";
	var resourcesArray = [];
	var resourcesCount = {};
	var preferDefault = function preferDefault(m) {
	  return m && m.default || m;
	};
	var prefetcher = void 0;
	var inInitialRender = true;
	var fetchHistory = [];
	var failedPaths = {};
	var failedResources = {};
	var MAX_HISTORY = 5;
	
	// Prefetcher logic
	if (true) {
	  prefetcher = __webpack_require__(328)({
	    getNextQueuedResources: function getNextQueuedResources() {
	      return resourcesArray.slice(-1)[0];
	    },
	    createResourceDownload: function createResourceDownload(resourceName) {
	      fetchResource(resourceName, function () {
	        resourcesArray = resourcesArray.filter(function (r) {
	          return r !== resourceName;
	        });
	        prefetcher.onResourcedFinished(resourceName);
	      });
	    }
	  });
	  _emitter2.default.on("onPreLoadPageResources", function (e) {
	    prefetcher.onPreLoadPageResources(e);
	  });
	  _emitter2.default.on("onPostLoadPageResources", function (e) {
	    prefetcher.onPostLoadPageResources(e);
	  });
	}
	
	var sortResourcesByCount = function sortResourcesByCount(a, b) {
	  if (resourcesCount[a] > resourcesCount[b]) {
	    return 1;
	  } else if (resourcesCount[a] < resourcesCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var sortPagesByCount = function sortPagesByCount(a, b) {
	  if (pathCount[a] > pathCount[b]) {
	    return 1;
	  } else if (pathCount[a] < pathCount[b]) {
	    return -1;
	  } else {
	    return 0;
	  }
	};
	
	var fetchResource = function fetchResource(resourceName) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	  if (resourceStrCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceStrCache[resourceName]);
	    });
	  } else {
	    // Find resource
	    var resourceFunction = void 0;
	    if (resourceName.slice(0, 12) === "component---") {
	      resourceFunction = asyncRequires.components[resourceName];
	    } else if (resourceName.slice(0, 9) === "layout---") {
	      resourceFunction = asyncRequires.layouts[resourceName];
	    } else {
	      resourceFunction = asyncRequires.json[resourceName];
	    }
	
	    // Download the resource
	    resourceFunction(function (err, executeChunk) {
	      resourceStrCache[resourceName] = executeChunk;
	      fetchHistory.push({
	        resource: resourceName,
	        succeeded: !err
	      });
	
	      if (!failedResources[resourceName]) {
	        failedResources[resourceName] = err;
	      }
	
	      fetchHistory = fetchHistory.slice(-MAX_HISTORY);
	      cb(err, executeChunk);
	    });
	  }
	};
	
	var getResourceModule = function getResourceModule(resourceName, cb) {
	  if (resourceCache[resourceName]) {
	    process.nextTick(function () {
	      cb(null, resourceCache[resourceName]);
	    });
	  } else if (failedResources[resourceName]) {
	    process.nextTick(function () {
	      cb(failedResources[resourceName]);
	    });
	  } else {
	    fetchResource(resourceName, function (err, executeChunk) {
	      if (err) {
	        cb(err);
	      } else {
	        var module = preferDefault(executeChunk());
	        resourceCache[resourceName] = module;
	        cb(err, module);
	      }
	    });
	  }
	};
	
	var appearsOnLine = function appearsOnLine() {
	  var isOnLine = navigator.onLine;
	  if (typeof isOnLine === "boolean") {
	    return isOnLine;
	  }
	
	  // If no navigator.onLine support assume onLine if any of last N fetches succeeded
	  var succeededFetch = fetchHistory.find(function (entry) {
	    return entry.succeeded;
	  });
	  return !!succeededFetch;
	};
	
	var handleResourceLoadError = function handleResourceLoadError(path, message) {
	  console.log(message);
	
	  if (!failedPaths[path]) {
	    failedPaths[path] = message;
	  }
	
	  if (appearsOnLine() && window.location.pathname.replace(/\/$/g, "") !== path.replace(/\/$/g, "")) {
	    window.location.pathname = path;
	  }
	};
	
	var mountOrder = 1;
	var queue = {
	  empty: function empty() {
	    pathArray = [];
	    pathCount = {};
	    resourcesCount = {};
	    resourcesArray = [];
	    pages = [];
	    pathPrefix = "";
	  },
	  addPagesArray: function addPagesArray(newPages) {
	    pages = newPages;
	    if (true) {
	      if (false) pathPrefix = __PATH_PREFIX__;
	    }
	    findPage = (0, _findPage2.default)(newPages, pathPrefix);
	  },
	  addDevRequires: function addDevRequires(devRequires) {
	    syncRequires = devRequires;
	  },
	  addProdRequires: function addProdRequires(prodRequires) {
	    asyncRequires = prodRequires;
	  },
	  dequeue: function dequeue() {
	    return pathArray.pop();
	  },
	  enqueue: function enqueue(rawPath) {
	    // Check page exists.
	    var path = (0, _stripPrefix2.default)(rawPath, pathPrefix);
	    if (!pages.some(function (p) {
	      return p.path === path;
	    })) {
	      return false;
	    }
	
	    var mountOrderBoost = 1 / mountOrder;
	    mountOrder += 1;
	    // console.log(
	    // `enqueue "${path}", mountOrder: "${mountOrder}, mountOrderBoost: ${mountOrderBoost}`
	    // )
	
	    // Add to path counts.
	    if (!pathCount[path]) {
	      pathCount[path] = 1;
	    } else {
	      pathCount[path] += 1;
	    }
	
	    // Add path to queue.
	    if (!queue.has(path)) {
	      pathArray.unshift(path);
	    }
	
	    // Sort pages by pathCount
	    pathArray.sort(sortPagesByCount);
	
	    // Add resources to queue.
	    var page = findPage(path);
	    if (page.jsonName) {
	      if (!resourcesCount[page.jsonName]) {
	        resourcesCount[page.jsonName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.jsonName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the JSON resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.jsonName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.jsonName);
	      }
	    }
	    if (page.componentChunkName) {
	      if (!resourcesCount[page.componentChunkName]) {
	        resourcesCount[page.componentChunkName] = 1 + mountOrderBoost;
	      } else {
	        resourcesCount[page.componentChunkName] += 1 + mountOrderBoost;
	      }
	
	      // Before adding, checking that the component resource isn't either
	      // already queued or been downloading.
	      if (resourcesArray.indexOf(page.componentChunkName) === -1 && !resourceStrCache[page.jsonName]) {
	        resourcesArray.unshift(page.componentChunkName);
	      }
	    }
	
	    // Sort resources by resourcesCount.
	    resourcesArray.sort(sortResourcesByCount);
	    if (true) {
	      prefetcher.onNewResourcesAdded();
	    }
	
	    return true;
	  },
	  getResources: function getResources() {
	    return {
	      resourcesArray: resourcesArray,
	      resourcesCount: resourcesCount
	    };
	  },
	  getPages: function getPages() {
	    return {
	      pathArray: pathArray,
	      pathCount: pathCount
	    };
	  },
	  getPage: function getPage(pathname) {
	    return findPage(pathname);
	  },
	  has: function has(path) {
	    return pathArray.some(function (p) {
	      return p === path;
	    });
	  },
	  getResourcesForPathname: function getResourcesForPathname(path) {
	    var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    if (inInitialRender && navigator && navigator.serviceWorker && navigator.serviceWorker.controller && navigator.serviceWorker.controller.state === "activated") {
	      // If we're loading from a service worker (it's already activated on
	      // this initial render) and we can't find a page, there's a good chance
	      // we're on a new page that this (now old) service worker doesn't know
	      // about so we'll unregister it and reload.
	      if (!findPage(path)) {
	        navigator.serviceWorker.getRegistrations().then(function (registrations) {
	          // We would probably need this to
	          // prevent unnecessary reloading of the page
	          // while unregistering of ServiceWorker is not happening
	          if (registrations.length) {
	            for (var _iterator = registrations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	              var _ref;
	
	              if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	              } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	              }
	
	              var registration = _ref;
	
	              registration.unregister();
	            }
	            window.location.reload();
	          }
	        });
	      }
	    }
	    inInitialRender = false;
	    // In development we know the code is loaded already
	    // so we just return with it immediately.
	    if (false) {
	      var page = findPage(path);
	      if (!page) return cb();
	      var pageResources = {
	        component: syncRequires.components[page.componentChunkName],
	        json: syncRequires.json[page.jsonName],
	        layout: syncRequires.layouts[page.layout],
	        page: page
	      };
	      cb(pageResources);
	      return pageResources;
	      // Production code path
	    } else {
	      if (failedPaths[path]) {
	        handleResourceLoadError(path, "Previously detected load failure for \"" + path + "\"");
	
	        return cb();
	      }
	
	      var _page = findPage(path);
	
	      if (!_page) {
	        handleResourceLoadError(path, "A page wasn't found for \"" + path + "\"");
	
	        return cb();
	      }
	
	      // Use the path from the page so the pathScriptsCache uses
	      // the normalized path.
	      path = _page.path;
	
	      // Check if it's in the cache already.
	      if (pathScriptsCache[path]) {
	        process.nextTick(function () {
	          cb(pathScriptsCache[path]);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: pathScriptsCache[path]
	          });
	        });
	        return pathScriptsCache[path];
	      }
	
	      _emitter2.default.emit("onPreLoadPageResources", { path: path });
	      // Nope, we need to load resource(s)
	      var component = void 0;
	      var json = void 0;
	      var layout = void 0;
	      // Load the component/json/layout and parallel and call this
	      // function when they're done loading. When both are loaded,
	      // we move on.
	      var done = function done() {
	        if (component && json && (!_page.layoutComponentChunkName || layout)) {
	          pathScriptsCache[path] = { component: component, json: json, layout: layout, page: _page };
	          var _pageResources = { component: component, json: json, layout: layout, page: _page };
	          cb(_pageResources);
	          _emitter2.default.emit("onPostLoadPageResources", {
	            page: _page,
	            pageResources: _pageResources
	          });
	        }
	      };
	      getResourceModule(_page.componentChunkName, function (err, c) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the component for " + _page.path + " failed");
	        }
	        component = c;
	        done();
	      });
	      getResourceModule(_page.jsonName, function (err, j) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the JSON for " + _page.path + " failed");
	        }
	        json = j;
	        done();
	      });
	
	      _page.layoutComponentChunkName && getResourceModule(_page.layout, function (err, l) {
	        if (err) {
	          handleResourceLoadError(_page.path, "Loading the Layout for " + _page.path + " failed");
	        }
	        layout = l;
	        done();
	      });
	
	      return undefined;
	    }
	  },
	  peek: function peek(path) {
	    return pathArray.slice(-1)[0];
	  },
	  length: function length() {
	    return pathArray.length;
	  },
	  indexOf: function indexOf(path) {
	    return pathArray.length - pathArray.indexOf(path) - 1;
	  }
	};
	
	var publicLoader = exports.publicLoader = {
	  getResourcesForPathname: queue.getResourcesForPathname
	};
	
	exports.default = queue;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	module.exports = [{"componentChunkName":"component---src-pages-404-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"404.json","path":"/404"},{"componentChunkName":"component---src-pages-biuro-rachunkowe-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"biuro-rachunkowe.json","path":"/biuro-rachunkowe"},{"componentChunkName":"component---src-pages-cennik-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"cennik.json","path":"/cennik"},{"componentChunkName":"component---src-pages-cookies-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"cookies.json","path":"/cookies"},{"componentChunkName":"component---src-pages-dotacje-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"dotacje.json","path":"/dotacje"},{"componentChunkName":"component---src-pages-faq-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"faq.json","path":"/faq"},{"componentChunkName":"component---src-pages-funkcje-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"funkcje.json","path":"/funkcje"},{"componentChunkName":"component---src-pages-index-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"index.json","path":"/"},{"componentChunkName":"component---src-pages-kalkulator-wynagrodzen-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"kalkulator-wynagrodzen.json","path":"/kalkulator-wynagrodzen"},{"componentChunkName":"component---src-pages-kontakt-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"kontakt.json","path":"/kontakt"},{"componentChunkName":"component---src-pages-likwidacja-spolek-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"likwidacja-spolek.json","path":"/likwidacja-spolek"},{"componentChunkName":"component---src-pages-nasz-zespol-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"nasz-zespol.json","path":"/nasz-zespol"},{"componentChunkName":"component---src-pages-polityka-rachunkowosci-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"polityka-rachunkowosci.json","path":"/polityka-rachunkowosci"},{"componentChunkName":"component---src-pages-porownanie-pakietow-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"porownanie-pakietow.json","path":"/porownanie-pakietow"},{"componentChunkName":"component---src-pages-program-do-faktur-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"program-do-faktur.json","path":"/program-do-faktur"},{"componentChunkName":"component---src-pages-regulamin-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"regulamin.json","path":"/regulamin"},{"componentChunkName":"component---src-pages-zakladanie-spolek-zoo-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"zakladanie-spolek-zoo.json","path":"/zakladanie-spolek-zoo"},{"componentChunkName":"component---src-pages-404-tsx","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-tsx","jsonName":"404-html.json","path":"/404.html"}]

/***/ }),

/***/ 328:
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = function (_ref) {
	  var getNextQueuedResources = _ref.getNextQueuedResources,
	      createResourceDownload = _ref.createResourceDownload;
	
	  var pagesLoading = [];
	  var resourcesDownloading = [];
	
	  // Do things
	  var startResourceDownloading = function startResourceDownloading() {
	    var nextResource = getNextQueuedResources();
	    if (nextResource) {
	      resourcesDownloading.push(nextResource);
	      createResourceDownload(nextResource);
	    }
	  };
	
	  var reducer = function reducer(action) {
	    switch (action.type) {
	      case "RESOURCE_FINISHED":
	        resourcesDownloading = resourcesDownloading.filter(function (r) {
	          return r !== action.payload;
	        });
	        break;
	      case "ON_PRE_LOAD_PAGE_RESOURCES":
	        pagesLoading.push(action.payload.path);
	        break;
	      case "ON_POST_LOAD_PAGE_RESOURCES":
	        pagesLoading = pagesLoading.filter(function (p) {
	          return p !== action.payload.page.path;
	        });
	        break;
	      case "ON_NEW_RESOURCES_ADDED":
	        break;
	    }
	
	    // Take actions.
	    // Wait for event loop queue to finish.
	    setTimeout(function () {
	      if (resourcesDownloading.length === 0 && pagesLoading.length === 0) {
	        // Start another resource downloading.
	        startResourceDownloading();
	      }
	    }, 0);
	  };
	
	  return {
	    onResourcedFinished: function onResourcedFinished(event) {
	      // Tell prefetcher that the resource finished downloading
	      // so it can grab the next one.
	      reducer({ type: "RESOURCE_FINISHED", payload: event });
	    },
	    onPreLoadPageResources: function onPreLoadPageResources(event) {
	      // Tell prefetcher a page load has started so it should stop
	      // loading anything new
	      reducer({ type: "ON_PRE_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onPostLoadPageResources: function onPostLoadPageResources(event) {
	      // Tell prefetcher a page load has finished so it should start
	      // loading resources again.
	      reducer({ type: "ON_POST_LOAD_PAGE_RESOURCES", payload: event });
	    },
	    onNewResourcesAdded: function onNewResourcesAdded() {
	      // Tell prefetcher that more resources to be downloaded have
	      // been added.
	      reducer({ type: "ON_NEW_RESOURCES_ADDED" });
	    },
	    getState: function getState() {
	      return { pagesLoading: pagesLoading, resourcesDownloading: resourcesDownloading };
	    },
	    empty: function empty() {
	      pagesLoading = [];
	      resourcesDownloading = [];
	    }
	  };
	};

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _apiRunnerBrowser = __webpack_require__(140);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(49);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouterDom = __webpack_require__(139);
	
	var _gatsbyReactRouterScroll = __webpack_require__(530);
	
	var _domready = __webpack_require__(475);
	
	var _domready2 = _interopRequireDefault(_domready);
	
	var _history = __webpack_require__(178);
	
	var _history2 = __webpack_require__(326);
	
	var _history3 = _interopRequireDefault(_history2);
	
	var _emitter = __webpack_require__(103);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _pages = __webpack_require__(552);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _redirects = __webpack_require__(553);
	
	var _redirects2 = _interopRequireDefault(_redirects);
	
	var _componentRenderer = __webpack_require__(324);
	
	var _componentRenderer2 = _interopRequireDefault(_componentRenderer);
	
	var _asyncRequires = __webpack_require__(323);
	
	var _asyncRequires2 = _interopRequireDefault(_asyncRequires);
	
	var _loader = __webpack_require__(209);
	
	var _loader2 = _interopRequireDefault(_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (true) {
	  __webpack_require__(389);
	}
	
	window.___history = _history3.default;
	
	window.___emitter = _emitter2.default;
	
	_loader2.default.addPagesArray(_pages2.default);
	_loader2.default.addProdRequires(_asyncRequires2.default);
	window.asyncRequires = _asyncRequires2.default;
	window.___loader = _loader2.default;
	window.matchPath = _reactRouterDom.matchPath;
	
	// Convert to a map for faster lookup in maybeRedirect()
	var redirectMap = _redirects2.default.reduce(function (map, redirect) {
	  map[redirect.fromPath] = redirect;
	  return map;
	}, {});
	
	var maybeRedirect = function maybeRedirect(pathname) {
	  var redirect = redirectMap[pathname];
	
	  if (redirect != null) {
	    _history3.default.replace(redirect.toPath);
	    return true;
	  } else {
	    return false;
	  }
	};
	
	// Check for initial page-load redirect
	maybeRedirect(window.location.pathname);
	
	// Let the site/plugins run code very early.
	(0, _apiRunnerBrowser.apiRunnerAsync)("onClientEntry").then(function () {
	  // Let plugins register a service worker. The plugin just needs
	  // to return true.
	  if ((0, _apiRunnerBrowser.apiRunner)("registerServiceWorker").length > 0) {
	    __webpack_require__(329);
	  }
	
	  var navigateTo = function navigateTo(to) {
	    var location = (0, _history.createLocation)(to, null, null, _history3.default.location);
	    var pathname = location.pathname;
	
	    var redirect = redirectMap[pathname];
	
	    // If we're redirecting, just replace the passed in pathname
	    // to the one we want to redirect to.
	    if (redirect) {
	      pathname = redirect.toPath;
	    }
	    var wl = window.location;
	
	    // If we're already at this location, do nothing.
	    if (wl.pathname === location.pathname && wl.search === location.search && wl.hash === location.hash) {
	      return;
	    }
	
	    // Listen to loading events. If page resources load before
	    // a second, navigate immediately.
	    function eventHandler(e) {
	      if (e.page.path === _loader2.default.getPage(pathname).path) {
	        _emitter2.default.off("onPostLoadPageResources", eventHandler);
	        clearTimeout(timeoutId);
	        window.___history.push(location);
	      }
	    }
	
	    // Start a timer to wait for a second before transitioning and showing a
	    // loader in case resources aren't around yet.
	    var timeoutId = setTimeout(function () {
	      _emitter2.default.off("onPostLoadPageResources", eventHandler);
	      _emitter2.default.emit("onDelayedLoadPageResources", { pathname: pathname });
	      window.___history.push(location);
	    }, 1000);
	
	    if (_loader2.default.getResourcesForPathname(pathname)) {
	      // The resources are already loaded so off we go.
	      clearTimeout(timeoutId);
	      window.___history.push(location);
	    } else {
	      // They're not loaded yet so let's add a listener for when
	      // they finish loading.
	      _emitter2.default.on("onPostLoadPageResources", eventHandler);
	    }
	  };
	
	  // window.___loadScriptsForPath = loadScriptsForPath
	  window.___navigateTo = navigateTo;
	
	  // Call onRouteUpdate on the initial page load.
	  (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", {
	    location: _history3.default.location,
	    action: _history3.default.action
	  });
	
	  var initialAttachDone = false;
	  function attachToHistory(history) {
	    if (!window.___history || initialAttachDone === false) {
	      window.___history = history;
	      initialAttachDone = true;
	
	      history.listen(function (location, action) {
	        if (!maybeRedirect(location.pathname)) {
	          // Make sure React has had a chance to flush to DOM first.
	          setTimeout(function () {
	            (0, _apiRunnerBrowser.apiRunner)("onRouteUpdate", { location: location, action: action });
	          }, 0);
	        }
	      });
	    }
	  }
	
	  function shouldUpdateScroll(prevRouterProps, _ref) {
	    var pathname = _ref.location.pathname;
	
	    var results = (0, _apiRunnerBrowser.apiRunner)("shouldUpdateScroll", {
	      prevRouterProps: prevRouterProps,
	      pathname: pathname
	    });
	    if (results.length > 0) {
	      return results[0];
	    }
	
	    if (prevRouterProps) {
	      var oldPathname = prevRouterProps.location.pathname;
	
	      if (oldPathname === pathname) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  var AltRouter = (0, _apiRunnerBrowser.apiRunner)("replaceRouterComponent", { history: _history3.default })[0];
	  var DefaultRouter = function DefaultRouter(_ref2) {
	    var children = _ref2.children;
	    return _react2.default.createElement(
	      _reactRouterDom.Router,
	      { history: _history3.default },
	      children
	    );
	  };
	
	  var ComponentRendererWithRouter = (0, _reactRouterDom.withRouter)(_componentRenderer2.default);
	
	  _loader2.default.getResourcesForPathname(window.location.pathname, function () {
	    var Root = function Root() {
	      return (0, _react.createElement)(AltRouter ? AltRouter : DefaultRouter, null, (0, _react.createElement)(_gatsbyReactRouterScroll.ScrollContext, { shouldUpdateScroll: shouldUpdateScroll }, (0, _react.createElement)(ComponentRendererWithRouter, {
	        layout: true,
	        children: function children(layoutProps) {
	          return (0, _react.createElement)(_reactRouterDom.Route, {
	            render: function render(routeProps) {
	              attachToHistory(routeProps.history);
	              var props = layoutProps ? layoutProps : routeProps;
	
	              if (_loader2.default.getPage(props.location.pathname)) {
	                return (0, _react.createElement)(_componentRenderer2.default, _extends({
	                  page: true
	                }, props));
	              } else {
	                return (0, _react.createElement)(_componentRenderer2.default, {
	                  page: true,
	                  location: { pathname: "/404.html" }
	                });
	              }
	            }
	          });
	        }
	      })));
	    };
	
	    var NewRoot = (0, _apiRunnerBrowser.apiRunner)("wrapRootComponent", { Root: Root }, Root)[0];
	
	    var renderer = (0, _apiRunnerBrowser.apiRunner)("replaceHydrateFunction", undefined, _reactDom2.default.render)[0];
	
	    (0, _domready2.default)(function () {
	      return renderer(_react2.default.createElement(NewRoot, null), typeof window !== "undefined" ? document.getElementById("___gatsby") : void 0, function () {
	        (0, _apiRunnerBrowser.apiRunner)("onInitialClientRender");
	      });
	    });
	  });
	});

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	module.exports = []

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _emitter = __webpack_require__(103);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/";
	if (false) {
	  pathPrefix = __PATH_PREFIX__ + "/";
	}
	
	if ("serviceWorker" in navigator) {
	  navigator.serviceWorker.register(pathPrefix + "sw.js").then(function (reg) {
	    reg.addEventListener("updatefound", function () {
	      // The updatefound event implies that reg.installing is set; see
	      // https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
	      var installingWorker = reg.installing;
	      console.log("installingWorker", installingWorker);
	      installingWorker.addEventListener("statechange", function () {
	        switch (installingWorker.state) {
	          case "installed":
	            if (navigator.serviceWorker.controller) {
	              // At this point, the old content will have been purged and the fresh content will
	              // have been added to the cache.
	              // We reload immediately so the user sees the new content.
	              // This could/should be made configurable in the future.
	              window.location.reload();
	            } else {
	              // At this point, everything has been precached.
	              // It's the perfect time to display a "Content is cached for offline use." message.
	              console.log("Content is now available offline!");
	              _emitter2.default.emit("sw:installed");
	            }
	            break;
	
	          case "redundant":
	            console.error("The installing service worker became redundant.");
	            break;
	        }
	      });
	    });
	  }).catch(function (e) {
	    console.error("Error during service worker registration:", e);
	  });
	}

/***/ }),

/***/ 210:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	/**
	 * Remove a prefix from a string. Return the input string if the given prefix
	 * isn't found.
	 */
	
	exports.default = function (str) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
	
	  if (str.substr(0, prefix.length) === prefix) return str.slice(prefix.length);
	  return str;
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _attributionService = __webpack_require__(212);
	
	var attribution = _interopRequireWildcard(_attributionService);
	
	var _googleAnalyticsService = __webpack_require__(8);
	
	var googleAnalyticsService = _interopRequireWildcard(_googleAnalyticsService);
	
	var _cookieConsentService = __webpack_require__(213);
	
	var cookieConsentService = _interopRequireWildcard(_cookieConsentService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Initial client load — Gatsby wywołuje RAZ, po hydration React'a w przeglądarce.
	 *
	 * Tu uruchamiamy TYLKO baner cookies (FAK-28914, T1) — od razu przy wejściu, także na localhost.
	 * GA4 i attribution NIE startują tutaj: włącza je baner (onAccept), i to wyłącznie po zgodzie.
	 * Jeśli zgoda jest już zapisana, baner woła onAccept od razu, więc GA działa zanim odpali onRouteUpdate.
	 *
	 * Bez wysyłania pageview ani touch — onRouteUpdate w Gatsby v1 ODPALA SIĘ TEŻ przy initial load
	 * (dla pierwszej routy), więc gdyby tu je wysłać, dostalibyśmy double-tracking.
	 */
	exports.onClientEntry = function () {
	  cookieConsentService.handleInitializeCookieConsent();
	};
	
	/**
	 * Każda zmiana routy w SPA navigation — Gatsby wywołuje TEŻ przy initial load
	 * (dla pierwszej routy), więc obsługuje zarówno direct visit/refresh jak i klik w <Link>.
	 *
	 * Gatsby 1.9 woła: onRouteUpdate({ location, action }, pluginOptions)
	 * (node_modules/gatsby/cache-dir/production-app.js), więc state.location.pathname to nowa ścieżka.
	 * Parametry page i pages nie istnieją — w v1 drugi argument to opcje pluginu.
	 *
	 * Obie funkcje same sprawdzają localhost i zgodę z banera — bez zgody nic nie wysyłają.
	 */
	exports.onRouteUpdate = function (state, page, pages) {
	  /** TRACKING PAGEVIEWS — GA4 */
	  googleAnalyticsService.trackPageview(state.location.pathname);
	
	  /** ATTRIBUTION TOUCH */
	  // Każda strona to potencjalny conversion path — touch leci do n8n.
	  // session_id pozostaje ten sam (z cookie), więc backend wie że to ten sam user.
	  attribution.touch(state.location.pathname);
	};

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  if (true) module.exports = definition()
	  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
	  else this[name] = definition()
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)
	
	
	  if (!loaded)
	  doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener)
	    loaded = 1
	    while (listener = fns.shift()) listener()
	  })
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn)
	  }
	
	});


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/* global document: false, __webpack_require__: false */
	patch();
	
	function patch() {
	  var head = document.querySelector("head");
	  var ensure = __webpack_require__.e;
	  var chunks = __webpack_require__.s;
	  var failures;
	
	  __webpack_require__.e = function (chunkId, callback) {
	    var loaded = false;
	    var immediate = true;
	
	    var handler = function handler(error) {
	      if (!callback) return;
	
	      callback(__webpack_require__, error);
	      callback = null;
	    };
	
	    if (!chunks && failures && failures[chunkId]) {
	      handler(true);
	      return;
	    }
	
	    ensure(chunkId, function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (immediate) {
	        // webpack fires callback immediately if chunk was already loaded
	        // IE also fires callback immediately if script was already
	        // in a cache (AppCache counts too)
	        setTimeout(function () {
	          handler();
	        });
	      } else {
	        handler();
	      }
	    });
	
	    // This is |true| if chunk is already loaded and does not need onError call.
	    // This happens because in such case ensure() is performed in sync way
	    if (loaded) {
	      return;
	    }
	
	    immediate = false;
	
	    onError(function () {
	      if (loaded) return;
	      loaded = true;
	
	      if (chunks) {
	        chunks[chunkId] = void 0;
	      } else {
	        failures || (failures = {});
	        failures[chunkId] = true;
	      }
	
	      handler(true);
	    });
	  };
	
	  function onError(callback) {
	    var script = head.lastChild;
	
	    if (script.tagName !== "SCRIPT") {
	      if (typeof console !== "undefined" && console.warn) {
	        console.warn("Script is not a script", script);
	      }
	
	      return;
	    }
	
	    script.onload = script.onerror = function () {
	      script.onload = script.onerror = null;
	      setTimeout(callback, 0);
	    };
	  }
	}

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

	function n(n){return n=n||Object.create(null),{on:function(c,e){(n[c]||(n[c]=[])).push(e)},off:function(c,e){n[c]&&n[c].splice(n[c].indexOf(e)>>>0,1)},emit:function(c,e){(n[c]||[]).slice().map(function(n){n(e)}),(n["*"]||[]).slice().map(function(n){n(c,e)})}}}module.exports=n;
	//# sourceMappingURL=mitt.js.map

/***/ }),

/***/ 810:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Pulled from react-compat
	// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
	function shallowDiffers(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }return false;
	}
	
	exports.default = function (instance, nextProps, nextState) {
	  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(178469467687848, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(361) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(3674329462689, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(362) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(82450655867835, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(363) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(42801046372026, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(364) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(142172943482554, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(365) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(120942155054859, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(366) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(148289615653256, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(367) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(221374088121123, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(368) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(183446267685356, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(369) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(8368097785865, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(370) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(173614995438892, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(371) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(90635188389249, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(372) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(66075490406564, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(373) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(247222586976726, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(374) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(250819134247684, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(375) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(147105165362510, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(376) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(
	      5
	    );
	    module.exports = function(cb) { return __webpack_require__.e/* nsure */(228497914701036, function(_, error) {
	        if (error) {
	          console.log('bundle loading error', error)
	          cb(true)
	        } else {
	          cb(null, function() { return __webpack_require__(377) })
	        }
	      });
	     }
	    

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	// =============================================================================
	//  attribution-service.ts — fakturomania-landing analytics tracker
	// =============================================================================
	//  Co to robi:
	//   - Wysyła "touch" (tj. zdarzenie page_view) do n8n endpointu po każdej zmianie strony
	//   - Zachowuje stabilne session_id w cookie (180 dni, cross-subdomain)
	//   - Łapie UTM-y, gclid/fbclid, referrer — żebyśmy wiedzieli skąd przyszedł użytkownik
	//   - Fail-silent — w razie błędu NIGDY nie psuje strony (try/catch wszędzie)
	//
	//  Endpoint przyjmuje JSON i odpowiada zawsze 204 (No Content) — fail silent na poziomie HTTP.
	//
	//  Zgoda (FAK-28914, T3):
	//   - fm_session to cookie ANALITYCZNE — zapisujemy je i wysyłamy touch WYŁĄCZNIE
	//     po zgodzie na 'analytics' w banerze. Bez zgody touch() nic nie robi.
	//
	//  Integracja:
	//   - gatsby-browser.js → onRouteUpdate woła touch()
	//   - cookie-consent-service.ts → po każdej decyzji woła handleUpdateAttributionConsent(),
	//     a gdy zgodę wyrażono w trakcie wizyty, woła touch() dla bieżącej strony
	// =============================================================================
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_service_1 = __webpack_require__(214);
	// =============================================================================
	//  Stałe konfiguracyjne — gdyby coś się zmieniło, edytuj tutaj
	// =============================================================================
	// Adres webhook'a w n8n — to tutaj wysyłamy każdy "touch". Zaczyna się od
	// "fakturomania-" zgodnie z konwencją wszystkich naszych webhooków.
	var N8N_ENDPOINT = 'https://n8n.fakturomania.pl/webhook/fakturomania-attribution-touch';
	// Nazwa cookie w której trzymamy nasz session_id (UUID v4). Krótka, "fm_" prefix
	// wskazuje że to nasze cookie (a nie GA, Freshdesk itp).
	var SESSION_COOKIE = 'fm_session';
	// Ile dni żyje cookie session_id. 180 dni = pół roku. Tak długi okres,
	// bo user może wrócić do nas po miesiącach od pierwszej wizyty (consideration cycle B2B).
	var SESSION_COOKIE_DAYS = 180;
	// Domain dla cookie z kropką na początku (".fakturomania.pl") — pozwala cookie
	// dzielić się między fakturomania.pl (landing) a app.fakturomania.pl (apka).
	// Dzięki temu user idzie z landingu do apki, a session_id się zachowuje.
	//
	// UWAGA: Na localhost / 127.0.0.1 (dev) przeglądarka ODRZUCA cookie z tym domain
	// (security policy: domain musi pasować do host). Funkcja getCookieDomain() niżej
	// auto-wykrywa dev environment i zwraca pusty string (= current host).
	var COOKIE_DOMAIN_PROD = '.fakturomania.pl';
	// Klucz w localStorage gdzie trzymamy aktualne zgody (analytics/marketing).
	// Używamy localStorage bo jest większy i prostszy niż cookie do trzymania JSON-a.
	var CONSENT_LS_KEY = 'fm_attribution_consent';
	// =============================================================================
	//  Cookie helpers — pomocnicze funkcje do czytania/zapisywania cookies
	// =============================================================================
	/**
	 * Czyta wartość cookie po nazwie. Zwraca null jeśli nie istnieje.
	 * Cookies w document.cookie są jednym stringiem typu: "name1=val1; name2=val2; name3=val3"
	 */
	function getCookie(name) {
	    // Sprawdź czy uruchomiamy się w przeglądarce. W Gatsby build (SSR) document nie istnieje.
	    if (typeof document === 'undefined') return null;
	    // Regex łapie "name=value" — ^| oznacza "początek stringa lub spacja przed".
	    // Druga grupa łapiąca ([^;]+) bierze wszystko aż do średnika (czyli value cookie).
	    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	    // Jeśli match istnieje — zwróć value (drugą grupę) zdekodowane z URL encoding.
	    // Inaczej null (cookie nie znalezione).
	    return match ? decodeURIComponent(match[2]) : null;
	}
	/**
	 * Auto-detect cookie domain — produkcja vs dev.
	 * Na localhost/127.0.0.1 NIE możemy ustawić domain=.fakturomania.pl (browser security),
	 * więc zwracamy pusty string (= cookie dla obecnego hosta tylko, np. localhost).
	 * Na produkcji zwracamy .fakturomania.pl żeby cookie było cross-subdomain.
	 */
	function getCookieDomain() {
	    // SSR fallback — w Gatsby build nie ma window
	    if (typeof window === 'undefined') return COOKIE_DOMAIN_PROD;
	    // Wyciągnij hostname (np. "localhost", "fakturomania.pl", "app.fakturomania.pl")
	    var host = window.location.hostname;
	    // Dev environments — localhost, 127.0.0.1, *.local (Linux/Mac mDNS)
	    // Brak domain w cookie = "tylko ten host" — przeglądarka akceptuje
	    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.local')) {
	        return '';
	    }
	    // Produkcja — pełna domena z kropką (cross-subdomain z app.fakturomania.pl)
	    return COOKIE_DOMAIN_PROD;
	}
	/**
	 * Zapisuje cookie z podanym name, value, ile dni i na jakiej domenie.
	 * Cookie jest zwykłym stringiem przypisanym do document.cookie — przeglądarka rozumie format.
	 */
	function setCookie(name, value, days, domain) {
	    // SSR safety — w Gatsby build nie ma document
	    if (typeof document === 'undefined') return;
	    // Oblicz datę wygaśnięcia: teraz + N dni × 86400000ms (sekund w dniu × 1000).
	    // toUTCString daje format który przeglądarka rozumie ("Wed, 21 Oct 2026 07:28:00 GMT")
	    var expires = new Date(Date.now() + days * 86400000).toUTCString();
	    // Część bazowa cookie — name=value + expires + path + SameSite (zawsze obecne)
	    // - encodeURIComponent: zabezpiecza wartość przed znakami specjalnymi (=, ;, spacje)
	    // - path=/: cookie dostępne na każdej ścieżce strony
	    // - SameSite=Lax: cookie wysyła się przy normalnej nawigacji (klik w link), ale nie w cross-site POST
	    var base = name + "=" + encodeURIComponent(value) + "; expires=" + expires + "; path=/; SameSite=Lax";
	    // Dopisz domain TYLKO jeśli niepusty (na localhost domain musi być pusty,
	    // inaczej przeglądarka odrzuca cookie z błędem "rejected for invalid domain").
	    var domainPart = domain ? "; domain=" + domain : '';
	    // Złożony cookie string przypisany do document.cookie — przeglądarka go zapisuje
	    document.cookie = base + domainPart;
	}
	// =============================================================================
	//  Session ID — UUID v4 w cookie
	// =============================================================================
	/**
	 * Generuje losowy UUID v4 (np. "550e8400-e29b-41d4-a716-446655440000").
	 * Format: 8-4-4-4-12 hex characters. v4 oznacza że jest losowe (nie z czasu/MAC).
	 */
	function generateUUIDv4() {
	    // Nowoczesna metoda: crypto.randomUUID() (Chrome 92+, Safari 15.4+, Firefox 95+).
	    // To jest cryptographically secure — niemożliwe do przewidzenia.
	    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
	        return crypto.randomUUID();
	    }
	    // Fallback dla starszych przeglądarek — Math.random nie jest crypto-secure,
	    // ale dla session_id (nie zabezpieczenie kryptograficzne) to OK.
	    // Replace zamienia każde "x" i "y" na losowy hex char zgodny z RFC4122 v4.
	    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	        // Losowa liczba 0-15
	        var r = Math.random() * 16 | 0;
	        // Dla "x" — dowolna; dla "y" — musi być 8/9/a/b (wymagania RFC4122 v4)
	        var v = c === 'x' ? r : r & 0x3 | 0x8;
	        // Zamień na hex (16 → "f", 10 → "a")
	        return v.toString(16);
	    });
	}
	/**
	 * Pobiera istniejący session_id z cookie LUB tworzy nowy i zapisuje.
	 * Dzięki temu user ma stabilne ID przez 180 dni (lub do wyczyszczenia cookies).
	 */
	function getOrCreateSessionId() {
	    // Spróbuj wyczytać istniejące cookie
	    var sid = getCookie(SESSION_COOKIE);
	    // Jeśli nie ma — wygeneruj nowy i zapisz
	    if (!sid) {
	        sid = generateUUIDv4();
	        // getCookieDomain() zwraca '.fakturomania.pl' na produkcji, '' na localhost
	        setCookie(SESSION_COOKIE, sid, SESSION_COOKIE_DAYS, getCookieDomain());
	    }
	    // Zwróć (istniejący lub świeżo utworzony)
	    return sid;
	}
	// =============================================================================
	//  URL parsing — wyciąganie UTM/click_ids z aktualnego adresu
	// =============================================================================
	/**
	 * Wyciąga UTM parameters z URL. Obiekt URL ma .searchParams które jest
	 * jak Map — ma .get(nazwa) zwracające string lub null.
	 * Konwertujemy null → undefined żeby JSON.stringify pominął te pola
	 * (zamiast wysyłać "utm_source": null).
	 */
	function parseUTM(url) {
	    var params = url.searchParams;
	    return {
	        source: params.get('utm_source') || undefined,
	        medium: params.get('utm_medium') || undefined,
	        campaign: params.get('utm_campaign') || undefined,
	        term: params.get('utm_term') || undefined,
	        content: params.get('utm_content') || undefined
	    };
	}
	/**
	 * Wyciąga click_ids z URL — analogicznie do UTM, ale z innych pól.
	 * Te ID-ki dodają reklamy automatycznie do URL po kliknięciu.
	 */
	function parseClickIds(url) {
	    var params = url.searchParams;
	    return {
	        gclid: params.get('gclid') || undefined,
	        fbclid: params.get('fbclid') || undefined,
	        msclkid: params.get('msclkid') || undefined
	    };
	}
	// =============================================================================
	//  Device detection — proste UA parsing bez zewnętrznych bibliotek
	// =============================================================================
	/**
	 * Wykrywa typ urządzenia, przeglądarkę i rozdzielczość ekranu.
	 * Używamy navigator.userAgent — string opisujący przeglądarkę
	 * (np. "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 ... Chrome/120 ...").
	 */
	function getDeviceInfo() {
	    // SSR safety — w Gatsby build navigator nie istnieje
	    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
	        return { type: 'unknown', browser_family: 'unknown', screen_resolution: 'unknown' };
	    }
	    // Pełny user agent string — różne przeglądarki różnie się przedstawiają
	    var ua = navigator.userAgent;
	    // iPad i Android tablet (z "Android" ale bez "Mobile" w UA — Android phones mają "Mobile")
	    var isTablet = /iPad|Android(?!.*Mobile)/i.test(ua);
	    // Mobile = iPhone, iPod, Android phone (NOT już wykryte jako tablet)
	    var isMobile = !isTablet && /Mobi|Android|iPhone|iPod/i.test(ua);
	    // Określ typ na podstawie powyższych flag (kolejność ważna: tablet > mobile > desktop)
	    var type = isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop';
	    // Wykryj przeglądarkę. Edge musi być przed Chrome bo Edge UA zawiera też "Chrome"
	    // (Edge jest na silniku Chromium). Safari musi być po Chrome bo Chrome UA też ma "Safari".
	    var browser_family = 'other';
	    if (/Edg\//.test(ua)) browser_family = 'Edge';else if (/Chrome\//.test(ua) && !/Edg\//.test(ua)) browser_family = 'Chrome';else if (/Firefox\//.test(ua)) browser_family = 'Firefox';else if (/Safari\//.test(ua) && !/Chrome\//.test(ua)) browser_family = 'Safari';
	    // Rozdzielczość ekranu (fizyczna, nie viewport) — np. "1920x1080".
	    // Jest typeof screen check bo czasem (rzadko, np. headless browser) screen może nie istnieć.
	    var screen_resolution = typeof screen !== 'undefined' ? screen.width + "x" + screen.height : 'unknown';
	    return { type: type, browser_family: browser_family, screen_resolution: screen_resolution };
	}
	// =============================================================================
	//  Consent state — odczyt/zapis zgód użytkownika do localStorage
	// =============================================================================
	/**
	 * Czyta aktualny stan zgód z localStorage.
	 * Domyślnie (przed pierwszym accept) zwracamy "ostrożny" tryb: tylko necessary.
	 * NIE zmieniaj na true — bez zgody touch() nie może nic wysłać (Polityka cookies, § 3 ust. 2).
	 */
	function getConsent() {
	    // SSR safety — w Gatsby build localStorage nie istnieje
	    if (typeof localStorage === 'undefined') {
	        return { necessary: true, analytics: false, marketing: false };
	    }
	    // try/catch bo localStorage może rzucić wyjątkiem (private browsing, quota)
	    try {
	        // Odczytaj string z localStorage
	        var raw = localStorage.getItem(CONSENT_LS_KEY);
	        // Brak zapisanych zgód — domyślnie tylko necessary.
	        // ⚠️ Bez zapisanej zgody analytics MUSI być false (Polityka cookies, § 3 ust. 2)
	        if (!raw) {
	            return { necessary: true, analytics: false, marketing: false };
	        }
	        // Parsuj JSON i zwróć z type assertion (TypeScript nie weryfikuje runtime)
	        return JSON.parse(raw);
	    } catch (_e) {
	        // Cokolwiek pójdzie nie tak — fail silent, zwróć defaults
	        return { necessary: true, analytics: false, marketing: false };
	    }
	}
	/**
	 * Zapisuje nowy stan zgód do localStorage. Wywoływane po consent accept/change.
	 */
	function saveConsent(analytics, marketing) {
	    // SSR safety
	    if (typeof localStorage === 'undefined') return;
	    // Zbuduj obiekt — necessary zawsze true (RODO wymaga że wymagane cookies muszą być)
	    var consent = { necessary: true, analytics: analytics, marketing: marketing };
	    // try/catch bo localStorage.setItem może rzucić (quota exceeded, disabled w incognito)
	    try {
	        localStorage.setItem(CONSENT_LS_KEY, JSON.stringify(consent));
	    } catch (_e) {
	        // Fail silent — nie blokujemy strony jeśli localStorage padnie
	    }
	}
	// =============================================================================
	//  Public API — funkcje które exportujemy do użycia w innych plikach
	// =============================================================================
	/**
	 * Wysyła page_view "touch" do n8n. NIE blokuje strony — sendBeacon jest fire-and-forget.
	 * Wywoływane z gatsby-browser.js (onRouteUpdate) i z cookie-consent-service.ts (zgoda w trakcie wizyty).
	 * Bez zgody na analitykę nic nie robi.
	 *
	 * @param landingPath — opcjonalna ścieżka strony (jeśli nie podana, wezmie z window.location.pathname)
	 */
	function touch(landingPath) {
	    // SSR safety — w Gatsby build window nie istnieje, omijamy
	    if (typeof window === 'undefined') return;
	    // Na localhost nie wysyłamy touchy do produkcyjnego n8n
	    if (environment_service_1.isLocalhost()) return;
	    // try/catch wokół całości — KRYTYCZNE: attribution NIGDY nie może crashnąć strony
	    try {
	        // Parsuj aktualny URL — daje wygodny dostęp do pathname, searchParams, hash, etc.
	        var url = new URL(window.location.href);
	        // Pobierz aktualny stan zgód. Bez zgody na analitykę nie zapisujemy fm_session
	        // i nic nie wysyłamy do n8n (FAK-28914, T3).
	        var consent = getConsent();
	        if (!consent.analytics) return;
	        var sid = getOrCreateSessionId();
	        // Zbuduj payload zgodny z kontraktem n8n /webhook/fakturomania-attribution-touch.
	        // Pola dokładnie takie jak walidacja w n8n flow oczekuje.
	        var payload = {
	            // Unikalny ID tego zdarzenia (idempotency w n8n — duplicate retry skipnie)
	            event_id: generateUUIDv4(),
	            // Stable ID sesji (cookie)
	            session_id: sid,
	            // Kiedy wysyłamy (ISO format z Z na końcu = UTC)
	            emitted_at: new Date().toISOString(),
	            // Landing nie zna user_id — to backend wpisze później po rejestracji.
	            // "as string | null" — type assertion: mówimy TypeScriptowi że to pole może być stringiem
	            // w przyszłości (gdy ktoś rozszerzy kod), inaczej TS zacieśniłby typ do literal "null".
	            user_id: null,
	            // UTM-y z URL (lub puste jeśli nie ma w URL)
	            utm: parseUTM(url),
	            // Click ID-ki od platform reklamowych
	            click_ids: parseClickIds(url),
	            // Skąd przyszedł user (np. "https://www.google.com/" jeśli kliknął w organic search).
	            // null jeśli direct visit (wpisał URL ręcznie lub bookmark).
	            referrer: document.referrer || null,
	            // Ścieżka strony bez query/hash (np. "/cennik")
	            landing_path: landingPath || url.pathname,
	            // Pełny URL z query, hash, etc.
	            full_url: url.href,
	            // Info o urządzeniu
	            device: getDeviceInfo(),
	            // Aktualne zgody — backend wie co może z tymi danymi zrobić
	            consent: consent
	        };
	        // Preferowany sposób: navigator.sendBeacon — wysyła w tle, nie blokuje nawigacji.
	        // Idealne dla page_view bo user może już klikać dalej, a my chcemy mieć dane.
	        //
	        // ⚠️ CORS TRICK: Używamy type "text/plain" zamiast "application/json".
	        // Powód: "application/json" to "non-simple request" → przeglądarka robi PREFLIGHT
	        // (osobny OPTIONS request), co wymaga że n8n umie obsłużyć OPTIONS + zwrócić CORS.
	        // "text/plain" jest CORS-safelisted → idzie BEZPOŚREDNIO bez preflight.
	        // n8n czyta body niezależnie od Content-Type i parsuje JSON wewnątrz workflow.
	        if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
	            // sendBeacon przyjmuje Blob — pakujemy JSON-a jako tekst plain
	            var blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
	            navigator.sendBeacon(N8N_ENDPOINT, blob);
	        } else {
	            // Fallback dla starszych przeglądarek (iOS < 13 itp.)
	            // keepalive: true — zachowuje request nawet gdy strona się zamknie
	            // credentials: omit — nie wysyłaj cookies/auth z naszej domeny do n8n
	            // text/plain content-type — analogicznie omija preflight
	            fetch(N8N_ENDPOINT, {
	                method: 'POST',
	                headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
	                body: JSON.stringify(payload),
	                keepalive: true,
	                credentials: 'omit'
	            }).catch(function () {});
	        }
	    } catch (e) {
	        // KRYTYCZNE: jeśli cokolwiek tu padnie — nie wybuchaj strony.
	        // W trybie deweloperskim wypisz w konsoli, w produkcji cisza.
	        if (false) {
	            // tslint:disable-next-line:no-console
	            console.warn('[attribution] touch failed (silenced):', e);
	        }
	    }
	}
	exports.touch = touch;
	/**
	 * Hook do cookie-consent-service.ts — wywoływany po każdej decyzji w banerze
	 * (i przy wejściu, gdy zgoda jest już zapisana). Tylko zapisuje stan zgód —
	 * touch dla bieżącej strony wysyła cookie-consent-service, gdy zgodę wyrażono w trakcie wizyty.
	 */
	function handleUpdateAttributionConsent(analyticsGranted, marketingGranted) {
	    // Zapisz nowy stan
	    saveConsent(analyticsGranted, marketingGranted);
	}
	exports.handleUpdateAttributionConsent = handleUpdateAttributionConsent;
	/**
	 * Diagnostic helper — do troubleshootingu z konsoli przeglądarki.
	 * Wywołaj: window.__fmAttributionDebug() w DevTools.
	 * Pokaże: aktualny session_id, consent, parsed UTM, device info.
	 * NIE używać w produkcji code path — tylko do debugowania.
	 */
	function __fmAttributionDebug() {
	    if (typeof window === 'undefined') return { error: 'SSR' };
	    var url = new URL(window.location.href);
	    return {
	        session_id: getCookie(SESSION_COOKIE),
	        consent: getConsent(),
	        utm: parseUTM(url),
	        click_ids: parseClickIds(url),
	        device: getDeviceInfo(),
	        endpoint: N8N_ENDPOINT
	    };
	}
	exports.__fmAttributionDebug = __fmAttributionDebug;
	// Wystawiamy debug helper na window żeby był dostępny z DevTools console.
	// (window as any) — TypeScript nie zna typu __fmAttributionDebug na window, force cast.
	if (typeof window !== 'undefined') {
	    window.__fmAttributionDebug = __fmAttributionDebug;
	}

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	// IMPORT DLA EFEKTU UBOCZNEGO => BIBLIOTEKA USTAWIA window.initCookieConsent.
	// Import wyżej TS usuwa (używany tylko jako typ), a baner startuje w onClientEntry, zanim załaduje się helmet-data.
	__webpack_require__(322);
	var google_analytics_service_1 = __webpack_require__(8);
	var attribution = __webpack_require__(212);
	/** INSTANCJA BANERA => POTRZEBNA DO OTWIERANIA USTAWIEŃ Z ODNOŚNIKA „PREFERENCJE PLIKÓW COOKIES” */
	var cookieConsentInstance = null;
	/** CZY ZGODA NA ANALITYKĘ BYŁA JUŻ ZASTOSOWANA => ŻEBY ROZPOZNAĆ, ŻE ZGODĘ WŁAŚNIE WYRAŻONO */
	var analyticsConsentApplied = false;
	/** KONFIGURACJA COOKIES */
	function getCookieConsentConfig() {
	    return {
	        current_lang: 'pl',
	        autoclear_cookies: true,
	        cookie_domain: 'fakturomania.pl',
	        cookie_name: 'fakturomania_cookie_consent',
	        cookie_expiration: 180,
	        cookie_same_site: 'Strict',
	        // WARTOŚĆ PRZEZ encodeURIComponent (RFC 6265) => SUROWY JSON ŁAMAŁ NAGŁÓWEK Cookie W BACKENDZIE (spray)
	        // ⚠️ CIASTECZKO WSPÓLNE Z APLIKACJĄ (fakturomania-react, cookie-consent.ts) => OBA BANERY MUSZĄ MIEĆ TĘ SAMĄ WARTOŚĆ,
	        // INACZEJ KAŻDY run() PRZEPISUJE ZGODĘ NA SWÓJ FORMAT I BŁĄD WRACA
	        use_rfc_cookie: true,
	        // ZMIANA KATEGORII (fm_session przeniesione z niezbędnych do analitycznych, FAK-28914)
	        // => PODBIJAMY REWIZJĘ, ŻEBY BANER POKAZAŁ SIĘ PONOWNIE (§ 3 ust. 6 Polityki cookies)
	        revision: 1,
	        page_scripts: true,
	        gui_options: {
	            consent_modal: {
	                layout: 'box',
	                position: 'bottom right',
	                transition: 'slide'
	            },
	            settings_modal: {
	                layout: 'box',
	                transition: 'slide'
	            }
	        },
	        // PIERWSZA DECYZJA W BANERZE => onRouteUpdate JUŻ MINĄŁ, WIĘC BIEŻĄCĄ STRONĘ TRZEBA ZLICZYĆ TERAZ
	        onFirstAction: function onFirstAction(userPreferences, cookie) {
	            handleUpdateCookieConsent(cookie.categories, true);
	        },
	        // WOŁANE TEŻ PRZY KAŻDYM WEJŚCIU, JEŚLI ZGODA JEST JUŻ ZAPISANA (PRZED onRouteUpdate, KTÓRY SAM ZLICZY STRONĘ)
	        onAccept: function onAccept(savedCookieContent) {
	            handleUpdateCookieConsent(savedCookieContent.categories, false);
	        },
	        onChange: function onChange(cookie, changedCookieCategories) {
	            handleUpdateCookieConsent(cookie.categories, true);
	        },
	        languages: {
	            'pl': {
	                consent_modal: {
	                    title: ' Używamy plików cookie! ',
	                    description: 'Witaj! Ta strona korzysta z niezbędnych plików cookie, aby zapewnić jej prawidłowe działanie. Dodatkowo używamy plików cookie śledzących, aby lepiej zrozumieć, jak z niej korzystasz. Te ostatnie zostaną zapisane tylko za Twoją zgodą. <button type="button" data-cc="c-settings" class="cc-link">Dostosuj ustawienia</button>',
	                    primary_btn: {
	                        text: 'Zaakceptuj wszystkie',
	                        role: 'accept_all'
	                    },
	                    secondary_btn: {
	                        text: 'Tylko niezbędne',
	                        role: 'accept_necessary'
	                    }
	                },
	                settings_modal: {
	                    title: 'Fakturomania.pl - Polityka plików cookie',
	                    save_settings_btn: 'Zapisz ustawienia',
	                    accept_all_btn: 'Zaakceptuj wszystkie',
	                    reject_all_btn: 'Odrzuć wszystkie',
	                    close_btn_label: 'Zamknij',
	                    cookie_table_headers: [{ col1: 'Nazwa' }, { col2: 'Domena' }, { col3: 'Czas przechowywania' }, { col4: 'Opis' }],
	                    blocks: [{
	                        title: 'Wykorzystanie plików cookie 📢',
	                        description: 'Pliki cookie są używane do zapewnienia podstawowej funkcjonalności strony oraz do poprawy Twojego doświadczenia. Możesz zarządzać zgodą dla każdej kategorii. Szczegółowe informacje znajdziesz w <a href="https://fakturomania.pl/cookies" target="_blank" class="cc-link">Polityce cookies</a>.'
	                    }, {
	                        title: 'Niezbędne pliki cookie',
	                        description: 'Te pliki cookie są wymagane do prawidłowego działania strony i nie można ich wyłączyć.',
	                        toggle: {
	                            value: 'necessary',
	                            enabled: true,
	                            readonly: true
	                        },
	                        // T7 (FAK-28915): tabela w banerze to wykaz plików, do którego odsyła Polityka cookies (§ 4 ust. 6)
	                        cookie_table: [
	                        // ZAPAMIĘTANY WYBÓR Z BANERA (Polityka cookies § 3 ust. 6)
	                        {
	                            col1: 'fakturomania_cookie_consent',
	                            col2: 'fakturomania.pl',
	                            col3: '180 dni',
	                            col4: '[Fakturomania] - Zapamiętuje wybór dokonany w banerze cookies.'
	                        }, {
	                            col1: 'fm_attribution_consent',
	                            col2: 'fakturomania.pl (pamięć lokalna)',
	                            col3: 'Do usunięcia',
	                            col4: '[Fakturomania] - Zapamiętuje wybór dokonany w banerze cookies na potrzeby skryptu źródła wejść.'
	                        },
	                        // FRESHDESK => CZAT I CENTRUM POMOCY SĄ NIEZBĘDNE (Polityka cookies § 4 ust. 1 pkt 1)
	                        {
	                            col1: '_fw_crm_v',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: '1 rok',
	                            col4: '[Freshchat/Freshworks] - Plik cookie (używany do śledzenia tożsamości odwiedzającego/użytkownika i sesji czatu prowadzonych przez użytkownika).'
	                        }, {
	                            col1: '_x_w',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Zawiera identyfikator fragmentu, na którym działa konto.'
	                        }, {
	                            col1: '_x_m',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Zawiera stan fragmentu.'
	                        }, {
	                            col1: '_helpkit_session',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Twój tajny klucz do weryfikacji integralności danych sesji plików cookie. Jeśli zmienisz ten klucz, wszystkie stare sesje stracą ważność!'
	                        }, {
	                            col1: 'helpdesk_node_session',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Zaszyfrowany hash przechowujący tajny klucz i identyfikator próby logowania.'
	                        }, {
	                            col1: 'user_credentials',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: '2 miesiące',
	                            col4: '[Freshchat/Freshworks] - Używany do uwierzytelniania użytkownika.'
	                        }, {
	                            col1: 'wf_order',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Służy do sprawdzenia, w jakiej kolejności zgłoszenia są filtrowane dla niestandardowych filtrów zgłoszeń, np.: termin, odpowiedź konsultanta o, odpowiedź zgłaszającego o, itp.'
	                        }, {
	                            col1: 'wf_order_type',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Służy do sprawdzania, czy kolejność jest rosnąca, czy malejąca dla niestandardowych filtrów zgłoszeń.'
	                        }, {
	                            col1: 'wf_filter',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Wskazuje, który filtr jest stosowany do listy zgłoszeń.'
	                        }, {
	                            col1: '__cf_bm',
	                            col2: 'pomoc.fakturomania.pl',
	                            col3: 'Sesja',
	                            col4: '[Freshchat/Freshworks] - Ciasteczko od Cloudflare jest używane do identyfikacji i ograniczenia ruchu automatycznego, co ma na celu ochronę Twojej strony przed szkodliwymi botami. Ciasteczko to pomaga w rozróżnianiu ludzkich użytkowników od botów, co jest kluczowe dla bezpieczeństwa i wydajności witryny, zapobiegając nadużyciom i atakom.'
	                        }]
	                    }, {
	                        title: 'Analityczne pliki cookie',
	                        description: 'Pliki te pomagają w analizowaniu, jak użytkownicy korzystają ze strony.',
	                        toggle: {
	                            value: 'analytics',
	                            enabled: true,
	                            readonly: false
	                        },
	                        cookie_table: [
	                        // === ATTRIBUTION COOKIE ===
	                        // fm_session jest analityczne, nie niezbędne (FAK-28914, T3): zapisujemy je
	                        // i wysyłamy touche do n8n dopiero po zgodzie na 'analytics'.
	                        // Wpis w tabeli = autoclear usuwa je po wycofaniu zgody.
	                        {
	                            col1: 'fm_session',
	                            col2: '.fakturomania.pl',
	                            col3: '180 dni',
	                            col4: '[Fakturomania] - Identyfikator wizyty. Pozwala łączyć wizyty w jedną ścieżkę (np. od reklamy do rejestracji) i ustalić, z jakiego źródła trafiłeś do Serwisu. Po rejestracji lub zalogowaniu może zostać przypisany do Konta.'
	                        },
	                        // GOOGLE ANALYTICS 4 => gtag zapisuje je we własnej domenie Serwisu (nie google.com), _gid GA4 nie używa
	                        {
	                            col1: '_ga',
	                            col2: '.fakturomania.pl',
	                            col3: '2 lata',
	                            col4: '[Google Analytics] - Rozróżnia użytkowników na potrzeby statystyk korzystania z Serwisu.'
	                        }, {
	                            col1: '_ga_XK3JNR74PF',
	                            col2: '.fakturomania.pl',
	                            col3: '2 lata',
	                            col4: '[Google Analytics] - Przechowuje stan sesji na potrzeby statystyk korzystania z Serwisu.'
	                        }]
	                    }, {
	                        title: 'Reklamowe i marketingowe pliki cookie',
	                        description: 'Pliki cookie śledzące pozwalają dostosować reklamy do Twoich preferencji.',
	                        toggle: {
	                            value: 'targeting',
	                            enabled: true,
	                            readonly: false
	                        },
	                        cookie_table: [
	                        // GOOGLE ADS => wpis potrzebny, żeby autoclear usuwał je przy braku zgody
	                        {
	                            col1: '_gcl_au',
	                            col2: '.fakturomania.pl',
	                            col3: '90 dni',
	                            col4: '[Google Ads] - Służy do pomiaru skuteczności reklam Fakturomanii (konwersji).'
	                        },
	                        // PAMIĘĆ LOKALNA => autoclear jej nie czyści, usuwa ją handleUpdateCookieConsent (T4)
	                        {
	                            col1: '_gcl_ls',
	                            col2: 'fakturomania.pl (pamięć lokalna)',
	                            col3: 'Do usunięcia',
	                            col4: '[Google Ads] - Zapisuje informację o kliknięciu w reklamę Fakturomanii.'
	                        }, {
	                            col1: 'hp2_id',
	                            col2: 'freshworks.com',
	                            col3: '2 lata',
	                            col4: '[Freshchat/Freshworks] - Ciasteczka te mogą być umieszczane na naszej stronie przez naszych partnerów reklamowych. Służą do tworzenia profilu Twoich zainteresowań i wyświetlania odpowiednich reklam na innych stronach. Nie przechowują bezpośrednio informacji osobistych, ale opierają się na unikalnym identyfikowaniu Twojej przeglądarki i urządzenia internetowego. Jeśli ich nie zaakceptujesz, będziesz otrzymywać mniej spersonalizowane reklamy.'
	                        }]
	                    }]
	                }
	            }
	        }
	    };
	}
	/**
	 * Uruchamia baner RAZ, przy wejściu na stronę (gatsby-browser.js => onClientEntry).
	 * Jeśli zgoda jest już zapisana, biblioteka od razu woła onAccept => GA i attribution startują przed onRouteUpdate.
	 * Jeśli nie ma zgody, pokazuje baner, a GA i attribution czekają na decyzję.
	 */
	function handleInitializeCookieConsent() {
	    // JUŻ URUCHOMIONY => NIC NIE ROBIMY
	    if (cookieConsentInstance) return;
	    console.log("Initializing Cookie Consent");
	    cookieConsentInstance = window.initCookieConsent();
	    cookieConsentInstance.run(getCookieConsentConfig());
	    // BRAK WAŻNEJ ZGODY (PIERWSZA WIZYTA, WYGASŁA ALBO NOWA REWIZJA)
	    // => CZYŚCIMY ZGODY ZAPAMIĘTANE PRZEZ ATTRIBUTION, ŻEBY NIE WYSŁAĆ TOUCHA PRZED DECYZJĄ W BANERZE
	    if (!cookieConsentInstance.validConsent()) {
	        attribution.handleUpdateAttributionConsent(false, false);
	    }
	}
	exports.handleInitializeCookieConsent = handleInitializeCookieConsent;
	/** OTWIERA USTAWIENIA BANERA => ODNOŚNIK „PREFERENCJE PLIKÓW COOKIES” W STOPCE */
	function showCookieSettings() {
	    if (!cookieConsentInstance) {
	        handleInitializeCookieConsent();
	    }
	    cookieConsentInstance.showSettings(0);
	}
	exports.showCookieSettings = showCookieSettings;
	function handleUpdateCookieConsent(allowedCategories, trackCurrentPage) {
	    // DANE UNIWERSALNE
	    // Sprawdzamy czy w tablicy zaakceptowanych kategorii jest 'analytics' (>-1 oznacza "znalezione")
	    var analyticsGranted = allowedCategories.indexOf('analytics') > -1;
	    // Analogicznie dla 'targeting' (czyli marketing/advertising)
	    var advertisingGranted = allowedCategories.indexOf('targeting') > -1;
	    // Powiadom GA4 o zmianie zgód — Google Tag Manager dostaje "consent update" event
	    google_analytics_service_1.handleUpdateGA4Consent(analyticsGranted, advertisingGranted);
	    // === ATTRIBUTION ===
	    // Powiadom też nasz attribution-service o nowych zgodach.
	    // Wewnętrznie zapisuje stan w localStorage i emit-uje świeży touch
	    // żeby backend dostał update zgód (i mógł wzbogacić analitykę).
	    attribution.handleUpdateAttributionConsent(analyticsGranted, advertisingGranted);
	    // ZGODA NA ANALITYKĘ WYRAŻONA W TRAKCIE WIZYTY => ZLICZAMY BIEŻĄCĄ STRONĘ (GA4 + TOUCH DO n8n)
	    var analyticsJustGranted = analyticsGranted && !analyticsConsentApplied;
	    analyticsConsentApplied = analyticsGranted;
	    if (trackCurrentPage && analyticsJustGranted) {
	        google_analytics_service_1.trackPageview(window.location.pathname);
	        attribution.touch(window.location.pathname);
	    }
	    // === PAMIĘĆ LOKALNA (T4, FAK-28915) ===
	    // autoclear_cookies czyści tylko cookies z tabel => klucze localStorage usuwamy sami (Polityka cookies § 3 ust. 5)
	    if (!advertisingGranted) {
	        removeLocalStorageKeys(MARKETING_LOCAL_STORAGE_KEYS);
	    }
	}
	/** KLUCZE PAMIĘCI LOKALNEJ Z KATEGORII MARKETINGOWEJ => MUSZĄ ZGADZAĆ SIĘ Z TABELĄ W BANERZE */
	var MARKETING_LOCAL_STORAGE_KEYS = ['_gcl_ls'];
	function removeLocalStorageKeys(keys) {
	    // try/catch bo localStorage może rzucić wyjątkiem (np. zablokowane dane witryny)
	    try {
	        keys.forEach(function (key) {
	            return localStorage.removeItem(key);
	        });
	    } catch (e) {
	        // Fail silent — nie blokujemy strony
	    }
	}

/***/ })

});


// WEBPACK FOOTER //
// app-6a75daa6c846f26c83a5.js